import React, { useEffect, useRef, useState, useContext } from "react";
import Button from "../button/Button";
import { ClipLoader } from "react-spinners";
import { CurrentUserContext } from "../../../App";
import { CloudArrowUpIcon } from "@heroicons/react/24/outline";
import { ImBin } from "react-icons/im";

function UploadImageMultiple({ type, value, setValue, api, title, limit }) {
  const { setIsMessage } = useContext(CurrentUserContext);
  const inputFileRef = useRef(null);
  
  const currentValues = Array.isArray(value) ? value : value ? [value] : [];
  
  const [uploading, setUploading] = useState(false);

  let acceptType;
  if (type === "image") {
    acceptType = "image/png, image/jpg, image/jpeg";
  } else if (type === "file") {
    acceptType = "application/pdf";
  } else {
    acceptType = type;
  }

  const inputFileChange = async (event) => {
    const selectedFiles = Array.from(event.target.files);
    if (selectedFiles.length === 0) return;

    setUploading(true);
    const uploadResults = [...currentValues];

    for (const file of selectedFiles) {
      // Check Limit
      if (limit) {
        const fileSizeInMB = file.size / (1024 * 1024);
        if (fileSizeInMB > limit) {
          setIsMessage({ type: 'warning', data: `ไฟล์ ${file.name} ขนาดใหญ่เกินไป` });
          continue;
        }
      }

      try {
        let formData = { data: file };
        let res = await api(formData);

        if (res["data"]["code"] === 200) {
          uploadResults.push(res["data"]["url"]);
        } else {
          setIsMessage({ type: 'warning', data: res?.data?.message_th || `โหลด ${file.name} ไม่สำเร็จ` });
        }
      } catch (error) {
        setIsMessage({ type: 'error', data: `เกิดข้อผิดพลาดในการอัปโหลด ${file.name}` });
      }
    }

    setValue(uploadResults);
    setUploading(false);
    event.target.value = null;
  };

  const removeImage = (indexToRemove) => {
    const updated = currentValues.filter((_, index) => index !== indexToRemove);
    setValue(updated);
  };

  return (
    <div className="flex flex-col gap-4 items-center w-full">
      <div className="flex flex-wrap gap-4 justify-center">
        {currentValues.map((url, index) => (
          <div key={index} className="relative border rounded-lg p-2 bg-white shadow-sm">
            {type === "image" ? (
              <div className="flex flex-col gap-2 items-center">
                <img
                  src={url}
                  className="w-[120px] h-[80px] object-cover rounded"
                  alt={`uploaded-${index}`}
                />
                <button
                  onClick={() => removeImage(index)}
                  className="p-1.5 rounded-full bg-red-500 text-white hover:bg-red-600 transition-colors"
                >
                  <ImBin size={14} />
                </button>
              </div>
            ) : (
              <div className="flex items-center gap-2 px-2">
                <a
                  href={url}
                  target="_blank"
                  rel="noreferrer"
                  className="text-white text-xs bg-[#06A7AD] px-3 py-1.5 rounded hover:bg-[#058d92]"
                >
                  ดูไฟล์ {index + 1}
                </a>
                <button
                  onClick={() => removeImage(index)}
                  className="text-red-500 hover:text-red-700"
                >
                  <ImBin />
                </button>
              </div>
            )}
          </div>
        ))}
      </div>

      <input
        multiple
        accept={acceptType}
        type="file"
        ref={inputFileRef}
        onChange={inputFileChange}
        className="hidden"
      />

      <div className="flex flex-col items-center">
        <Button
          onClick={() => !uploading && inputFileRef.current.click()}
          disabled={uploading}
          style={{
            width: "300px",
            height: "125px",
            background: "#FFFFFF",
            border: "1px dashed #AEE7E8",
            borderRadius: "14px",
            color: "#06A7AD",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            cursor: uploading ? "not-allowed" : "pointer"
          }}
        >
          {uploading ? (
            <div className="flex flex-col items-center gap-2">
              <ClipLoader size={30} color="#06A7AD" />
              <span className="text-sm">กำลังอัปโหลด...</span>
            </div>
          ) : (
            <>
              <CloudArrowUpIcon className="w-10 h-10 mb-2" />
              <div className="text-center px-4">
                คลิกเพื่อเลือกหลายไฟล์ <br />
                <span className="text-xs opacity-70">(คลุมดำเลือกหลายไฟล์ได้)</span>
              </div>
            </>
          )}
        </Button>
        {title && <div className="text-[#06A7AD] text-[12px] mt-2">{title}</div>}
      </div>
    </div>
  );
}

export default UploadImageMultiple;